import { FC } from 'react';
import Banner from '@/components/UI/Banner';

interface InvalidMetadataBannerProps {
  invalidFields: Record<string, string>;
  actionText?: string;
  className?: string;
  dismiss?: boolean;
}

const InvalidMetadataBanner: FC<InvalidMetadataBannerProps> = ({
  invalidFields,
  actionText,
  className = 'mb3',
  dismiss = false,
}) => {
  const fieldCount = Object.keys(invalidFields).length;
  const fieldEntries = Object.entries(invalidFields);
  const isPlural = fieldCount > 1;

  const defaultActionText = isPlural
    ? 'Select valid options for these fields before saving.'
    : 'Select valid options for this field before saving.';

  return (
    <Banner warning className={className} dismiss={dismiss}>
      <h3 className="db mb1">Invalid metadata values</h3>
      <p className="ma0 lh-copy">
        {isPlural
          ? 'The following fields had values that are no longer valid: '
          : 'The following field had values that are no longer valid: '}
        {fieldEntries.map(([slug, title], index) => (
          <span key={slug}>
            <strong>{title}</strong>
            {index < fieldEntries.length - 1 ? ', ' : '. '}
          </span>
        ))}
        {actionText ?? defaultActionText}
      </p>
    </Banner>
  );
};

export default InvalidMetadataBanner;
